<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="rows"
      hide-default-footer
      :items-per-page="10000"
    />
  </v-card>
</template>

<script>
  export default {
    props: {
      rows: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    data: function() {
      return {
        headers: [
          {text: 'Nome', value: 'nome_veiculo'},
          {text: 'Fonte', value: 'fonte'},
          {text: 'Segmento', value: 'segmento'},
          {text: 'Estado', value: 'estado'},
          {text: 'Região', value: 'regiao'},
          {text: 'Cidade', value: 'cidade'},
          {text: 'Cód Mun', value: 'cod_mun_ibge'},
          {text: 'Endereço', value: 'address'},
          {text: 'E-mail', value: 'email'},
          {text: 'Funcionários', value: 'num_funcionarios'},
          {text: 'Periodicidade', value: 'periodicity'},
          {text: 'Jornalismo', value: 'eh_jornal'},
          {text: 'Data Fechamento', value: 'data_fechamento'},
          {text: 'Canais', value: 'media_channel_data'},
          {text: 'Modelos de Negócios', value: 'media_business_models'},
          {text: 'Características', value: 'media_features'}
        ]
      }
    }
  };
</script>

<style scoped>

</style>
